/**
 * Scripts
 */
$(document).ready(function () {
    const sliderHomeFoto = () => {
        const homeSliderFoto = document.querySelectorAll('.slider-foto'); // container above slider
        homeSliderFoto.forEach(sliderWrapper => {
            const slider = sliderWrapper.querySelector('.slider-foto__sl'); // container with slider
            const controlsContainerD = sliderWrapper.querySelector('.slider-control');

            const sliderHomeFotos = tns({
                container: slider,
                mouseDrag: true,
                nav: false,
                loop: false,
                controlsContainer: controlsContainerD,
                responsive: {
                    350: {
                        items: 1,
                        gutter: 0,

                    },
                    500: {
                        items: 3.5,
                        gutter: 50,
                    }
                }
            });
        });
    };

    if($('.slider-foto__sl').length > 0) {
        sliderHomeFoto();
    }

    $('.submenu .close').on('click', function (e) {
        e.preventDefault();

        if($(window).width() > 768) {
            $('.submenu').toggleClass('open');

            $('.submenu .btn').toggleClass('menor');
        } else {
            $('.bolinhas').toggleClass('esconde');
            $('.menu-hide').toggleClass('open');

            $('.close').toggleClass('xis');
        }
    });

    $('.menu-sb-action li').on('click', function (e){
        e.preventDefault();

        var link = $(this).data('link');

        window.location.href = link;
    });

    $('.submenu .more').hover( function (e){
        e.preventDefault();

        $(this).find('i').toggleClass('open');
        $(this).find('ul').slideToggle();
    })

    if($('.ch-footer').length > 0) {
        gsap.to(".ch-footer", {
            scrollTrigger: {
                trigger: ".ch-footer",
                start: "top 100%",
                end: "bottom bottom",
                //once: true,
                //markers: true,
                scrub: 1,
                onEnter: () => {
                    $('.denuncie').fadeOut();
                },
                onLeaveBack: () => {
                    $('.denuncie').fadeIn();
                },
            }
        });
    }
    //
    // //categorias
    $('.down-cat__bloco .titulo').on('click', function (e) {
        e.preventDefault();

        $(this).closest('.down-cat__bloco').find('.button').toggleClass('open');

        $(this).closest('.down-cat__bloco').find('.conteudo').slideToggle();
    });

    //
    //
    // //quem somos
    $('.team .bl').on('click', function () {
        $(this).find('.img i').toggleClass('open');
        $(this).find('.int').slideToggle();
    });
    //
    const sliderRelatorios = () => {
        const relatoriosSlider = document.querySelectorAll('.rel'); // container above slider

        relatoriosSlider.forEach(sliderWrapper => {
            const slider = sliderWrapper.querySelector('.rel-sl'); // container with slider
            const controlsContainerD = sliderWrapper.querySelector('.slider-control');

            if(slider) {
                const sliderRels = tns({
                    container: slider,
                    mouseDrag: true,
                    nav: false,
                    loop: false,
                    controlsContainer: controlsContainerD,
                    responsive: {
                        350: {
                            items: 1,
                            gutter: 0,

                        },
                        500: {
                            items: 3,
                            gutter: 0,
                        }
                    }
                });
            }
        });
    };

    if($('.rel').length > 0) {
        sliderRelatorios();
    }

    $('.menu-publi .princ').on('click', function (e){
        e.preventDefault();

        $(this).toggleClass('open');
        $(this).closest('.botao').find('.sub').slideToggle();
    });

    //glosario
    $(document).on('click', '.glossario .titulo a', function (e) {
        e.preventDefault();

        $(this).closest('.bloco').find('.titulo span').toggleClass('open');
        $(this).closest('.bloco').find('.texto').slideToggle();
    });

    //mapa
    $('.mapa-menu .btn').on('click', function (e) {
        e.preventDefault();

        var cor = $(this).data('cor');
        var estados = $(this).data('estados');

        $('.svg-map').removeClass('multicolor');
        $('.svg-map .estado path').css('fill', '#fbf6ec');
        $('.svg-map .estado path').css('stroke', cor);
        $('.dados .dt span').css('color', cor);

        estados.estados.forEach(function (i){
            $('.svg-map').find('.'+i+' path').css('fill', cor);
        });

        var qtd = $(this).data('qtd');
        $('.dados .total').text(qtd);

        var percent = $(this).data('porcentagem');
        $('.dados .percent').text(percent+'%')
    });

    if($('.timeline').length > 0) {
        const sliderTimeline = tns({
            container: '.timeline-sl',
            mouseDrag: true,
            nav: false,
            loop: false,
            items: 1,
            mode: 'gallery',
            controlsContainer : '.timeline-control'
        });


        sliderTimeline.events.on('transitionStart', function (info, eventName) {
            const inf = sliderTimeline.getInfo();

            var bloco = $('.timeline .bloco').eq(info.index);
            var ano = bloco[0].getAttribute('data-ano');

            $('.timeline .year').text(ano);

        });
    }

    $('.galeria-arrow button').on('click', function () {
        var $galeria = $(this).closest('.bloco').find('.post-galeria');
        var $imagem = $galeria.find('.galeria-imagem');
        var $galeriaImagem = $galeria.find('.galeria-imagem.active');
        var $detalhes = $galeria.find('.legenda-credito.active');

        var galeriaQtd = parseInt($imagem.length);
        galeriaQtd = galeriaQtd - 1;


        //direita
        if ($(this).hasClass('right')) {
            if($galeriaImagem.next().length === 0 ) {
                $galeriaImagem.removeClass('active');
                $imagem.eq(0).addClass('active');
            } else {
                $galeriaImagem.removeClass('active');
                $galeriaImagem.next().addClass('active');
            }

            //legenda-credito
            if($detalhes.next().length === 0 ) {
                $detalhes.removeClass('active')
                $galeria.find('.legenda-credito').eq(0).addClass('active');
            } else {
                $detalhes.removeClass('active')
                $detalhes.next().addClass('active');
            }
        }

        //esquerda
        if ($(this).hasClass('left')) {
            if($galeriaImagem.prev().length === 0 ) {
                $galeriaImagem.removeClass('active');
                $imagem.eq(galeriaQtd).addClass('active');
            } else {
                $galeriaImagem.removeClass('active');
                $galeriaImagem.prev().addClass('active');
            }

            //legenda-credito
            if($detalhes.prev().length === 0 ) {
                $detalhes.removeClass('active')
                $galeria.find('.legenda-credito').eq(galeriaQtd).addClass('active');
            } else {
                $detalhes.removeClass('active')
                $detalhes.prev().addClass('active');
            }
        }
    });

    if($('.depoimentos').length > 0) {
        const sliderDep = tns({
            container: '.depoimentos__sl',
            mouseDrag: true,
            nav: false,
            loop: false,
            items: 1,
            controlsContainer : '.depoimentos .slider-control'
        });
    }

    if($('.numeros_sl').length > 0){
        const sliderNumero = tns({
            container: '.numeros_sl',
            mouseDrag: true,
            nav: false,
            loop: false,
            items: 1.7,
            controlsContainer : '.numeros .slider-control'
        });
    }

    $('.menu-institucional .titulo').on('click', function (e) {
        e.preventDefault();

        if($(window).width() <= 768) {
            $('.insti-lista').slideToggle();
            $('.menu-institucional .titulo i').toggleClass('gira');
        }
    });


    if($('.listagem-insta').length > 0) {
        cardsInsta(document.querySelectorAll('.card-insta'));
    }

    if ($(".pagination-infi").length > 0){
        $('.pagination-infi').infiniteScroll({
            path: '.nextpostslink',
            append: '.col',
            hideNav: '.wp-pagenavi',
            history: false
        });
    }

});

function cardsInsta(cards) {
    const rotations = [-5, -8, -2, -6, 1, 2, 3, 4, 8];

    cards.forEach(card => {
        if (!card.classList.contains('transformed')) { // só aplica se ainda não foi transformado
            const rotation = rotations[Math.floor(Math.random() * rotations.length)];

            card.style.transform = `rotate(${rotation}deg)`;

            card.classList.add('transformed'); // marca como já estilizado
        }
    });

    //qdo aplicar o scroll!
    // Suponha que você adicionou os novos cards dentro de um elemento .row
    // const novosCards = document.querySelectorAll('.card:not(.transformed)');
    // aplicarEstiloAleatorio(novosCards);
}

$.fn.rotationInfo = function() {
    var el = $(this),
        tr = el.css("-webkit-transform") || el.css("-moz-transform") || el.css("-ms-transform") || el.css("-o-transform") || '',
        info = {rad: 0, deg: 0};
    if (tr = tr.match('matrix\\((.*)\\)')) {
        tr = tr[1].split(',');
        if(typeof tr[0] != 'undefined' && typeof tr[1] != 'undefined') {
            info.rad = Math.atan2(tr[1], tr[0]);
            info.deg = parseFloat((info.rad * 180 / Math.PI).toFixed(1));
        }
    }
    return info;
};

var lastScrollTop = 0;
var altura = $(window).height();

$(window).scroll(function () {
    var scrollY = $(window).scrollTop();

    if(scrollY < lastScrollTop) {
        if(scrollY >= altura) {
            if($('.ch-menu').hasClass('esconde')) {
                $('.ch-menu').removeClass('esconde');
            }
        }

        if(scrollY < (altura - altura/2) && $('body').hasClass('home')) {
            $('.submenu').fadeOut();
        }
    }

    if(scrollY > lastScrollTop) {
        if(scrollY > altura + (altura / 2)) {
            // if(!$('.ch-menu').hasClass('esconde')) {
            //     $('.ch-menu').addClass('esconde');
            // }
        }

    }

    lastScrollTop = scrollY;
});

( function() {

    var youtube = document.querySelectorAll( ".youtube" );

    for (var i = 0; i < youtube.length; i++) {

        var source = "https://img.youtube.com/vi/"+ youtube[i].dataset.embed +"/maxresdefault.jpg";


        var image = new Image();
        image.src = source;
        image.addEventListener( "load", function() {
            youtube[ i ].appendChild( image );
        }( i ) );

        youtube[i].addEventListener( "click", function() {

            var iframe = document.createElement( "iframe" );

            iframe.setAttribute( "frameborder", "0" );
            iframe.setAttribute( "allowfullscreen", "" );
            iframe.setAttribute( "src", "https://www.youtube.com/embed/"+ this.dataset.embed +"?rel=0&showinfo=0&autoplay=1" );

            this.innerHTML = "";
            this.appendChild( iframe );
        } );
    };

} )();